import React, { Component } from 'react'

import { connect } from 'react-redux'
import { Button, Modal } from 'react-bootstrap'

import PhaseOne from './PhaseOne'
// import PhaseTwo from './PhaseTwo'
// import PhaseThree from './PhaseThree'
// import PhaseFour from './PhaseFour'

import { resetPhase } from '../../reducers/manageProjectCreation'

class NewProject extends Component {

  state = {
    showModal: false
  }

  toggleShowModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  handleCancel = () => {
    this.setState({showModal: false}, () => this.props.resetPhase())
  }

  render () {
    // let displayComponent, headerText
    //
    // switch (this.props.projectCreationPhase) {
    //   case 1:
    //     displayComponent = <PhaseOne handleCancel={this.handleCancel}/>
    //     headerText = "New Project - Basic Data"
    //     break;
    //   case 2:
    //     displayComponent = <PhaseTwo handleCancel={this.handleCancel}/>
    //     headerText = "New Project - Leads and Analysts"
    //     break;
    //   case 3:
    //     displayComponent = <PhaseThree handleCancel={this.handleCancel}/>
    //     headerText = "New Project - Metadata"
    //     break;
    //   case 4:
    //     displayComponent = <PhaseFour handleCancel={this.handleCancel} history={this.props.history} />
    //     headerText = "New Project - Deliverables and Updates"
    //     break;
    //   default:
    //     displayComponent = null
    //     headerText = "New Project"
    //     break;
    // }

    const displayComponent = (
      <PhaseOne
        handleCancel={this.handleCancel}
        history={this.props.history}
      />
    )

    const headerText = "New Project - Basic Data"

    return (
      <div>
        <Button onClick={this.toggleShowModal}>
          New Project
        </Button>
        <div className="static-modal">
          <Modal show={this.state.showModal} keyboard={true}>
            <Modal.Header onHide={this.toggleShowModal} closeButton={true}>
              <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            {displayComponent}
          </Modal>
        </div>
      </div>
    )
  }
}

// const mapStateToProps = (state) => {
//   return {
//     projectCreationPhase: state.manageProjectCreation.phase
//   }
// }
//
// export default connect(mapStateToProps, { resetPhase })(NewProject)

export default connect(null, { resetPhase })(NewProject)



// WEBPACK FOOTER //
// ./src/routes/projects/components/project_creation/NewProject.js